export const permissionOptions = [
  { value: "FULL_ACCESS", label: "Full Access" },
  { value: "ST_ADM_ACCESS", label: "State Level Access" },
  { value: "TC_ADM_ACCESS", label: "TC Admin Level Access " },
  { value: "TC_USER_ACCESS", label: "TC User Level Access" },
  { value: "REPORT_ACCESS", label: "Report Level Access" },
  { value: "PVT_USER_ACCESS", label: "Private User Access" },
];
